import type { AccountSummary } from "../Accounts.helpers.ts";
import type { AccountTriggerMeta } from "./types.ts";

const DEFAULT_TRIGGER_META: AccountTriggerMeta = {
  label: "Todas as contas",
  badge: "\u00b7",
  badgeColor: "#667781",
};

export function getAccountTriggerMeta(
  summaries: AccountSummary[],
  filterSet: ReadonlySet<string>,
): AccountTriggerMeta {
  if (filterSet.size === 1) {
    const single = summaries.find((summary) => filterSet.has(summary.sessionId));
    if (single) {
      return {
        label: single.label,
        badge: single.badge,
        badgeColor: single.badgeColor,
      };
    }
  }

  if (filterSet.size === 0) {
    const fallback = summaries.find((summary) => summary.isDefault) || summaries[0];
    if (fallback) {
      return {
        label: `Todas (${summaries.length})`,
        badge: fallback.badge,
        badgeColor: fallback.badgeColor,
      };
    }
  }

  if (filterSet.size > 1) {
    return {
      ...DEFAULT_TRIGGER_META,
      label: `${filterSet.size} contas selecionadas`,
    };
  }

  return DEFAULT_TRIGGER_META;
}
